import { AddAssetsToCollections } from './AddAssetsToCollections'

export default AddAssetsToCollections
